import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { api, errorMessage } from '../api';
import { useAuth } from '../auth';
import { Alert, Field } from '../components/ui';

export function LoginPage() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={from && from !== '/login' ? from : '/batches'} replace />;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const r = await api.login({ email: email.trim(), password });
      setUser(r.user);
      navigate(from && from !== '/login' ? from : '/batches', { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1>Sign in</h1>
        <p className="muted">Insurance Import admin panel</p>
        <Field label="Email">
          {(id) => <input id={id} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" autoFocus />}
        </Field>
        <Field label="Password">
          {(id) => <input id={id} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />}
        </Field>
        {error && <Alert>{error}</Alert>}
        <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="muted small">Need an account? Ask an admin for an invite link.</p>
      </form>
    </div>
  );
}
